module.exports = __webpack_public_path__ + "img/logo.f243478a.png";